// Static-yet-alive gradient orbs floating in the background of the hero.
// CSS animations only — no per-frame work — for great performance.
const FloatingOrbs = () => {
    return (
        <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
            <div
                className="absolute -left-32 top-[-10%] h-[520px] w-[520px] rounded-full opacity-70 animate-orb-drift"
                style={{
                    background:
                        "radial-gradient(closest-side, rgba(59,130,246,0.35), rgba(59,130,246,0) 70%)",
                    filter: "blur(70px)"
                }}
            />
            <div
                className="absolute right-[-10%] top-[20%] h-[600px] w-[600px] rounded-full opacity-60 animate-orb-drift-2"
                style={{
                    background:
                        "radial-gradient(closest-side, rgba(6,182,212,0.30), rgba(6,182,212,0) 70%)",
                    filter: "blur(80px)"
                }}
            />
            <div
                className="absolute left-[30%] bottom-[-20%] h-[560px] w-[560px] rounded-full opacity-40 animate-orb-drift"
                style={{
                    background:
                        "radial-gradient(closest-side, rgba(147,197,253,0.20), rgba(147,197,253,0) 70%)",
                    filter: "blur(90px)"
                }}
            />
        </div>
    );
};

export default FloatingOrbs;
